import me from '@/store/me/actions/me';
import attribute from '@/store/me/actions/attribute';
import coverLetter from '@/store/me/actions/coverLetter';
import resume from '@/store/me/actions/resume';
import workExperience from '@/store/me/actions/workExperience';
import reference from '@/store/me/actions/reference';
import education from '@/store/me/actions/education';
import subscription from '@/store/me/actions/subscription';
import workLocation from '@/store/me/actions/workLocation';
import emailAlerts from '@/store/me/actions/emailAlerts';
import jobs from '@/store/me/actions/jobs';
import savedJob from '@/store/me/actions/savedJob';
import jobEvents from '@/store/me/actions/jobEvents';
import additionalDocument from '@/store/me/actions/additionalDocument';

export default {
    ...me,
    ...attribute,
    ...coverLetter,
    ...resume,
    ...workExperience,
    ...education,
    ...reference,
    ...subscription,
    ...workLocation,
    ...emailAlerts,
    ...jobs,
    ...savedJob,
    ...jobEvents,
    ...additionalDocument,
};
